<template>
  <v-container>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Licence</v-toolbar-title>
      </v-toolbar>
      <v-col sm="12">
        <v-progress-linear
            :active="loading"
            :indeterminate="loading"
            absolute
            color="#01579B"
            top
        ></v-progress-linear>
      </v-col>
      <v-data-table
          :expanded.sync="expanded"
          :headers="headers"
          :hide-default-footer="true"
          :items="licence"
          :items-per-page="10"
          :search="search"
          :single-expand="singleExpand"
          no-data-text="Aucun résultat"
          no-results-text="Aucun résultat"
          show-expand
      >
        <template v-slot:[`item.expirationDate`]="{ item }">
          {{ item.expirationDate | formatDate }}
        </template>
        <template v-slot:[`item.createdDate`]>
          {{ moment().format("DD-MM-YYYY HH:mm:ss") }}
        </template>
        <template v-slot:[`item.revisedDate`]>
          {{ diff }}
        </template>
        <template v-slot:[`item.action`]>
          <edit-licence-date-dialog
              :licence="licence"
          ></edit-licence-date-dialog>
        </template>
        <template v-slot:[`expanded-item`]="{ headers, item }">
          <td :colspan="headers.length">
            <vue-json-pretty :data="item"></vue-json-pretty>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import apiClient from "../../config/api.js";
import moment from "moment";

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  data() {
    return {
      isMobile: isMobileDevice(),
      dialog: false,
      moment: moment,
      search: "",
      loading: true,
      licence: [],
      headers: [
        {text: "Date d'expiration", value: "expirationDate"},
        {text: "Date du jour", value: "createdDate"},
        {text: "Nombre de jours restants", value: "revisedDate"},
        {text: "Actions", value: "action", sortable: false},
      ],
      expanded: [],
      singleExpand: true,
      editedIndex: -1,
      editedItem: {
        expirationDate: "",
      },
      x: null,
      y: "top",
      diff: 0,
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    licence(val) {
      this.diff = moment(val[0].expirationDate).diff(
          moment(new Date()),
          "days"
      );
    },
  },

  created() {
    apiClient.get(`${this.$store.getters.user.baseUrl}/admin/licence`)
        .then((response) => {
          setTimeout(() => (this.loading = false), 3000);
          this.licence.push(response.data.datas);
        })
        .catch(() => {
          this.loading = false;
        });
  },
  methods: {
    close() {
      this.dialog = false;
      this.expirationDate = "";
    },
    EditItem(item) {
      this.dialog = true;
      this.editedIndex = this.licence.indexOf(item);
      this.editedItem = Object.assign({}, item);
    },
  },
};
</script>

<style scoped>
tbody tr:nth-of-type(even) {
  background-color: rgba(236, 237, 237);
}

tbody tr:nth-of-type(odd) {
  background-color: rgb(250, 250, 250);
}
</style>
